<template>
  <v-layout row wrap>
    <v-flex>
      <v-widget class="px-0" :title="titulo" content-bg="white">
        <div slot="widget-content">
          <e-chart
            :path-option="[
              ['dataset.source', res],
              ['legend.bottom', '0'],
              [
                'color',
                [color.lightBlue.base, color.orange.base, color.grey.base],
              ],
              ['xAxis.show', false],
              ['yAxis.show', false],
              ['series[0].type', 'pie'],
              ['series[0].name', 'reporte'],
              ['series[0].avoidLabelOverlap', true],
              ['series[0].radius', ['50%', '70%']],
            ]"
            height="400px"
            width="100%"
          >
          </e-chart>
        </div>
      </v-widget>
    </v-flex>
  </v-layout>
</template>
<script>
import API from "@/api";
import EChart from "@/components/chart/echart";
import VWidget from "@/components/VWidget";
import Material from "vuetify/es5/util/colors";
import axios from "axios";
import { mapState } from "vuex";
import CircleStatistic from "@/components/widgets/statistic/CircleStatistic";
import { misMixins } from "@/mixins/myMixing.js";

export default {
  name: "boton-proceso",

  props: {
    res: "",
    titulo: "",
    titleIn: "",
  },

  components: {
    VWidget,
    EChart,
    CircleStatistic,
  },

  mixins: [misMixins],
  data: () => ({
    color: Material,
  }),

  computed: {},

  created() {
    this.id = this.$route.params.id;
  },

  methods: {},
};
</script>
